var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentNavigationList.some(function (nav,index){ return nav.path===_vm.$route.path; }))?_c('keep-alive',[_c('router-view',{on:{"hook:activated":_vm.onComponentActivated}})],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }